import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.237 14.671a.75.75 0 0 1-.75-.75V2.074a.75.75 0 0 1 1.5 0v11.847a.75.75 0 0 1-.75.75Zm-3.48-.751V7.151a.75.75 0 0 0-1.5 0v6.769a.75.75 0 0 0 1.5 0Zm-4.232 0v-3.384a.75.75 0 0 0-1.5 0v3.384a.75.75 0 0 0 1.5 0Zm-.272-7.085L8.23 2.858A.75.75 0 0 0 7.17 1.8L3.723 5.244 2.264 3.786A.75.75 0 0 0 1.2 4.847l1.992 1.988a.75.75 0 0 0 1.061 0Z';
const draw24px =
  'M17.9,20.75a.75.75,0,0,1-.75-.75V4a.75.75,0,0,1,1.5,0V20A.75.75,0,0,1,17.9,20.75ZM12.934,20V10.857a.75.75,0,0,0-1.5,0V20a.75.75,0,0,0,1.5,0ZM7.221,20V15.428a.75.75,0,0,0-1.5,0V20a.75.75,0,0,0,1.5,0Zm-.292-9.755L12.3,4.871a.75.75,0,0,0-1.061-1.06L6.4,8.654,4.242,6.5a.75.75,0,1,0-1.06,1.061l2.686,2.686a.75.75,0,0,0,1.061,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GraphCheckIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'graphCheck'),
) as IconWithRender;

GraphCheckIcon.displayName = 'GraphCheckIcon';
GraphCheckIcon.propTypes = Icon.propTypes;
GraphCheckIcon.renderIcon = (props) => <GraphCheckIcon {...props} />;
export default GraphCheckIcon;
